<template>
  <div class="mobile-nav-bar">
    <ul>
      <li :class="currPath.search(value.path) !== -1 ? 'active' : ''" v-for="(value, index) in routerNav" :key="index" @click="goTo(value.name)">
        {{value.title}}
      </li>
    </ul>
  </div>
</template>

<script>
import {routerObject} from "../router/index";
export default {
  name: 'mobileNavBar',
  data () {
    return {
      currPath: '/'
    }
  },
  computed: {
    routerNav () {
      return routerObject.filter(value => {
        return value.name && value.meta && value.meta.showNav
      }).map(value => {
        return {
          path: value.path,
          name: value.name,
          title: value.meta ? value.meta.title : ''
        }
      })
    }
  },
  methods: {
    goTo (path) {
      this.currPath = '/' + path
      if (this.$route.path === this.currPath) return false
      this.$router.push({ name: path })
      this.$store.commit('app/TOGGLE_MOBILE_BAR',false)
    }
  },
  created () {
    this.currPath = this.$route.path
  },
  watch:{
    $route () {
      this.currPath = this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-nav-bar{
  position: absolute;
  width: 100%;
  height: 100%;
  padding: p2r(39px) 0;
  background: rgba(247, 247, 247, 1);
  li{
    width: 100%;
    height: p2r(44px);
    box-sizing: border-box;
    padding: p2r(15px) p2r(17px);
    font-size: 14px;
    color: #333333;
    font-weight: 500;
  }
  .active{
    color: $bloodRed;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobileNavBar.vue